export default "__VITE_ASSET__vdCLJrB9__"